// TEMPORARY dev harness — renders the redesigned agent thread in isolation.
// Delete this file + its route.
import { ToolGroup } from '~/components/chat/tools/ToolGroup';
import { FileCard } from '~/components/chat/tools/FileCard';
import ThoughtBox from '~/components/chat/ThoughtBox';
import type { ToolPart } from '~/components/chat/message-parts';

const mk = (name: string, i: number): ToolPart => ({
  type: `tool-${name}`,
  toolCallId: `${name}-${i}`,
  state: 'output-available',
});

const GROUP1: ToolPart[] = [
  mk('read_files', 0),
  mk('list_files', 1),
  mk('component_library', 2),
  mk('typography_presets', 3),
];

const WRITE: ToolPart = {
  type: 'tool-write_file',
  toolCallId: 'w-1',
  state: 'output-available',
  input: { filePath: 'src/pages/About.tsx', content: Array(142).fill('line').join('\n') },
};
const EDIT: ToolPart = {
  type: 'tool-edit_file',
  toolCallId: 'e-1',
  state: 'output-available',
  input: {
    filePath: 'src/App.tsx',
    oldString: '<Route path="/" element={<Home />} />',
    newString: Array(8).fill('  <Route ... />').join('\n'),
  },
};

export default function DevThread() {
  return (
    <div className="w-full min-h-screen bg-page flex items-center justify-center p-6">
      <div className="w-full max-w-[560px]">
        <div className="flex gap-3">
          <div className="w-7 h-7 flex-none rounded-full bg-accent/15 border border-accent/30 grid place-items-center mt-0.5">
            <span className="i-ph:sparkle text-accent text-[13px]" />
          </div>
          <div className="flex-1 min-w-0 text-secondary text-[15px] leading-[1.62]">
            <p className="text-primary mb-3">
              On it — adding an <span className="text-secondary">About</span> page: a hero, a short story section, and a
              team grid, all on the dark system.
            </p>
            <ThoughtBox title="Planning the page structure">
              The current nav has room for one more link. I&apos;ll add an About route, build the page from the shared
              section components, and keep the dark system consistent.
            </ThoughtBox>
            <ToolGroup parts={GROUP1} isStreaming={false} />
            <FileCard part={WRITE} />
            <FileCard part={EDIT} />
            <p className="text-primary mt-3">
              The About page is live at <span className="font-geist-mono text-accent text-[13px]">/about</span> — hero,
              story, and a six-person team grid.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
